var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.374,
    r: 10,
    fill: "#102262"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.195 6.068a1.663 1.663 0 0 1 1.18 1.158c.283 1.025.292 3.148.292 3.148s0 2.133-.283 3.148a1.663 1.663 0 0 1-1.18 1.159c-1.036.277-5.204.277-5.204.277s-4.168 0-5.203-.277a1.663 1.663 0 0 1-1.181-1.159c-.283-1.024-.283-3.148-.283-3.148s0-2.123.274-3.14a1.663 1.663 0 0 1 1.181-1.158c1.036-.277 5.203-.285 5.203-.285s4.168 0 5.204.277Zm-3.073 4.306L8.665 12.34V8.41l3.457 1.964Z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;